import React from 'react';
import { DailyReport } from '../../services/dailyReportService';
import { Icon } from '../ui/Icon';

interface DailyReportCardProps {
  report: DailyReport;
}

export const DailyReportCard: React.FC<DailyReportCardProps> = ({ report }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        <div className="text-center p-2">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Icon name="bolt" size="sm" color="primary" />
            <div className="text-xl font-bold text-blue-600 dark:text-blue-400">
              {report.total_energy_kwh.toLocaleString(undefined, { maximumFractionDigits: 1 })}
            </div>
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">Total Energy (kWh)</div>
        </div>
        
        <div className="text-center p-2">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Icon name="sun" size="sm" color="success" />
            <div className="text-xl font-bold text-green-600 dark:text-green-400">
              {report.specific_yield.toFixed(2)}
            </div>
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">Specific Yield (kWh/kWp)</div>
        </div>
        
        <div className="text-center p-2">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Icon name="chart-bar" size="sm" color="warning" />
            <div className="text-xl font-bold text-orange-600 dark:text-orange-400">
              {report.cuf.toFixed(2)}%
            </div>
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">CUF</div>
        </div>
        
        <div className="text-center p-2">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Icon name="chart-pie" size="sm" color="info" />
            <div className="text-xl font-bold text-purple-600 dark:text-purple-400">
              {report.pr.toFixed(2)}%
            </div>
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">PR</div>
        </div>
        
        <div className="text-center p-2">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Icon name="beaker" size="sm" color="success" />
            <div className="text-xl font-bold text-emerald-600 dark:text-emerald-400">
              {report.co2_saved_tons.toFixed(2)}
            </div>
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">CO₂ Saved (Tons)</div>
        </div>
      </div>
    </div>
  );
};